import { Injectable } from '@angular/core';
import { BaseProvider } from './base-provider';
import { DarkModeNotifier } from '../notifiers/dark-mode-notifier';

@Injectable({ providedIn: 'root' })
export class DarkModeProvider extends BaseProvider<DarkModeNotifier, boolean> {
  constructor() {
    super(DarkModeNotifier);
  }
}
